import { Salutation } from "@ews/react-data";
import { IonCol } from "@ionic/react";
import React from "react";
import { useIsMobile } from "../../../../../Responsive";
import SettingsSelect from "../../../../../Settings/SettingsComponents/SettingsSelect/SettingsSelect";
import SettingsSelectOption from "../../../../../Settings/SettingsComponents/SettingsSelectOption/SettingsSelectOption";
import SettingsTextInput from "../../../../../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";
import GPSArea from "../../../../GPSArea/GPSArea";
import { InvoiceAddress } from "./types";

export const Content: React.FC<
    {
        invoiceAddress: Partial<InvoiceAddress>,
        onData: (value: any, attribute: keyof InvoiceAddress | "address") => void;
    }> = ({
        invoiceAddress,
        onData
    }) =>
    {
        const mobileView = useIsMobile();

        const Wrapper = mobileView ? React.Fragment : IonCol;

        return <>
            <Wrapper>
                <SettingsTextInput
                    text={"[REACT_E-MAIL_PURCHASING_OFFICER]"}
                    value={invoiceAddress.notifyLicenseExpiration}
                    required
                    onChange={(value) => onData(value, "notifyLicenseExpiration")}
                />
                <SettingsTextInput
                    text={"[REACT_UST-IDNR.]"}
                    value={invoiceAddress.ustIdNr}
                    required
                    onChange={(value) => onData(value, "ustIdNr")}
                />
                <SettingsSelect
                    text={"COM_FACPMANAGEMENT_USERS_SALUTATION"}
                    value={invoiceAddress.salutation}
                    onSelect={(value) => onData(value, "salutation")}
                >
                    {Object.keys(Salutation).map((salutation) =>
                    {
                        return <SettingsSelectOption key={salutation} text={`[REACT_SALUTATION.${salutation.toUpperCase()}]`} value={salutation} />;
                    })}
                </SettingsSelect>
                <SettingsTextInput
                    text={"COM_CONTENT_HEADING_TITLE"}
                    value={invoiceAddress.firstTitle}
                    onChange={(value) => onData(value, "firstTitle")}
                />

                <SettingsTextInput
                    text={"COM_FACPMANAGEMENT_USERS_FIRSTNAME"}
                    value={invoiceAddress.firstName}
                    required
                    onChange={(value) => onData(value, "firstName")}
                />
                <SettingsTextInput
                    text={"[REACT_SECOND_FIRST_NAME]"}
                    value={invoiceAddress.secondFirstName}
                    onChange={(value) => onData(value, "secondFirstName")}
                />
                <SettingsTextInput
                    text={"COM_FACPMANAGEMENT_USERS_LASTNAME"}
                    value={invoiceAddress.lastName}
                    required
                    onChange={(value) => onData(value, "lastName")}
                />
            </Wrapper >
            <Wrapper>
                <SettingsTextInput
                    text={"COM_VIRTUEMART_SHOPPER_FORM_COMPANY_NAME"}
                    value={invoiceAddress.companyName}
                    required
                    onChange={(value) => onData(value, "companyName")}
                />
                <SettingsTextInput
                    text={"COM_CONTACT_FAX"}
                    value={invoiceAddress.fax}
                    onChange={(value) => onData(value, "fax")}
                />
                <SettingsTextInput
                    text={"COM_FACPMANAGEMENT_PHONE_FIELD_PHONE_LABEL"}
                    value={invoiceAddress.phoneNumber}
                    onChange={(value) => onData(value, "phoneNumber")}
                />

                <SettingsTextInput
                    text={"[REACT_MOBILE_PHONE_NUMBER]"}
                    value={invoiceAddress.mobilePhoneNumber}
                    onChange={(value) => onData(value, "mobilePhoneNumber")}
                />


                <SettingsTextInput
                    text={"[REACT_EMAIL_FOR_INVOICE_RECEIPT]"}
                    value={invoiceAddress.invoiceEmail}
                    required
                    onChange={(value) => onData(value, "invoiceEmail")}
                />
            </Wrapper >
            <Wrapper>
                <GPSArea
                    onlyPoint
                    onChange={(value) =>
                    {
                        if (value) {
                            const { city, country, street, zip } = value;

                            const address = {
                                city: city || "",
                                country: country || "",
                                address1: street || "",
                                zip: zip || ""
                            };
                            onData(address, "address");

                        }
                    }}
                />
            </Wrapper>
        </>;
    };